import use911informNotification from './use911informNotification';

/**
 * Container component that will house the logic for sending browser push
 * notifications;
 * @param {Function} onClickNotification - callback function for
 * when a notification is clicked
 */
const AppNotifications = ({ onClickNotification }) => {
  use911informNotification(onClickNotification);
  return null;
};

export default AppNotifications;
